import { DevModeSettings, LocalstorageKeys } from '@aibees/shared/definition';
import type { AxiosInstance } from 'axios';

const devModeSettings = JSON.parse(
  localStorage.getItem(LocalstorageKeys.DevSettings) ?? '{}'
) as DevModeSettings;

const CUSTOM_URL_CONFIG = devModeSettings.customBaseUrl?.filter(
  (x) => !!x.enabled && !!x.contains
);

export function applyCustomApiUrlInterceptor(instance: AxiosInstance) {
  if (import.meta.env.VITE_APP_STAGE === 'prod') return;

  instance.interceptors.request.use((config) => {
    const customConfig = CUSTOM_URL_CONFIG?.findLast((x) =>
      config.url?.includes(x.contains)
    );
    if (customConfig) config.baseURL = customConfig?.custom;
    return config;
  });
}
